import { useRef, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'pages/Chart/Chart.redux';



const useChartAutoSave = () => {
    const dispatch = useDispatch(),
          interval = useSelector(state => state.chart.autoSaveInterval),
          enabled  = useSelector(state => state.chart.autoSaveEnabled);

    const autoSaveIntervalRef = useRef(null),
          progressIntervalRef = useRef(null),
          cycleStartRef       = useRef(Date.now()),
          [ progress, setProgress ] = useState(0);

    const resetTimer = useCallback(() => {
        cycleStartRef.current = Date.now();
        setProgress(0);
    }, []);

    useEffect(() => {
        clearInterval(autoSaveIntervalRef.current);
        clearInterval(progressIntervalRef.current);

        if(!enabled || interval <= 0) {
            setProgress(0);
            return;
        }

        const intervalInMs = interval * 1000;

        resetTimer();

        autoSaveIntervalRef.current = setInterval(() => {
            dispatch(actions.saveChart(true));
            resetTimer();
        }, intervalInMs);

        progressIntervalRef.current = setInterval(() => {
            const elapsed = Date.now() - cycleStartRef.current;
            const nextProgress = Math.min((elapsed / intervalInMs) * 100, 100);
            setProgress(nextProgress);
        }, 200);

        return () => {
            clearInterval(autoSaveIntervalRef.current);
            clearInterval(progressIntervalRef.current);
        };
    }, [ interval, enabled, dispatch, resetTimer ]);

    return [ enabled, interval, progress, resetTimer ];
};

export default useChartAutoSave;